type SVGProps = {
  width?: string | number;
  height?: string | number;
};

const Placeholder = ({ width, height }: SVGProps) => (
  <svg
    focusable={false}
    xmlns='http://www.w3.org/2000/svg'
    width={width || 16}
    height={height || 16}
    viewBox='0 0 80 80'
  >
    <circle cx='40' cy='40' r='40' fill='#fff' />
  </svg>
);

export default Placeholder;
